import * as _ from "lodash";
import { isEqual } from "lodash";
import * as React from "react";

import { AreaType } from "../types/index";
import ToggleButtonGroup from "./ToggleButtonGroup";

interface Props {
  onChange: (areaType: AreaType[]) => void;
  areaType: AreaType[];
}

class AreaTypeFilter extends React.Component<Props> {
  private inAreaSelected = (): boolean =>
    isEqual(this.props.areaType, [AreaType.IA]);
  private outOfAreaSelected = (): boolean =>
    isEqual(this.props.areaType, [AreaType.OOA]);
  private allAreasSelected = (): boolean =>
    _.includes(this.props.areaType, AreaType.IA) &&
    _.includes(this.props.areaType, AreaType.OOA);

  private buttons = [
    {
      label: "Alle",
      selected: () => this.allAreasSelected(),
      onClick: () => this.props.onChange([AreaType.IA, AreaType.OOA]),
    },
    {
      label: "In Area",
      selected: () => this.inAreaSelected(),
      onClick: () => this.props.onChange([AreaType.IA]),
    },
    {
      label: "Out Of Area",
      selected: () => this.outOfAreaSelected(),
      onClick: () => this.props.onChange([AreaType.OOA]),
    },
  ];
  public render() {
    return <ToggleButtonGroup title="Kundenregion" buttons={this.buttons} />;
  }
}

export default AreaTypeFilter;



// WEBPACK FOOTER //
// ./src/components/AreaTypeFilter.tsx